<template>
  <footer>
    <h1>footer</h1>
  </footer>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
footer{
  width: 100%;
  height: 60px;
  color: #fff;
  line-height: 60px;
  position: absolute;
  bottom: 0;
  z-index: 999;
  padding: 0 136px;
  background-color: #23383f;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// index.vue?3d7eb22b